import { render } from "./ManualDetail.vue?vue&type=template&id=313848d6&scoped=true"
import script from "./ManualDetail.vue?vue&type=script&lang=js"
export * from "./ManualDetail.vue?vue&type=script&lang=js"

import "./ManualDetail.vue?vue&type=style&index=0&id=313848d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313848d6"]])

export default __exports__